import { render, staticRenderFns } from "./PublicCalendarNew.vue?vue&type=template&id=3aad5bbe&scoped=true&"
import script from "./PublicCalendarNew.vue?vue&type=script&lang=js&"
export * from "./PublicCalendarNew.vue?vue&type=script&lang=js&"
import style0 from "./PublicCalendarNew.vue?vue&type=style&index=0&id=3aad5bbe&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3aad5bbe",
  null
  
)

export default component.exports